const GROUP = {
  AT_LAST_1_MEMBER: 'Please select at least 1 group member.',
  CREATED: 'Group created.',
  NOT_FOUND: 'Group not found.',
  DELETED: 'Group deleted.',
  UPDATED: 'Group updated.',
  MEMBER_CREATED: 'Group member added.',
  MEMBER_DELETED: 'Group member deleted.',
  MEMBER_EXISTS: 'Group member already added.',
  MEMBER_NOT_FOUND: 'Group member not found',
  MEMBERS_ADDED_TO_GROUPS: 'Groups updated.',
  DUPLICATE: 'Group name already exists.',
} as const;

export default GROUP;
